// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var HeatmapSymbolTitleBy;
(function (HeatmapSymbolTitleBy) {
    HeatmapSymbolTitleBy[HeatmapSymbolTitleBy["Symbol"] = 0] = "Symbol";
    HeatmapSymbolTitleBy[HeatmapSymbolTitleBy["Description"] = 1] = "Description";
})(HeatmapSymbolTitleBy || (HeatmapSymbolTitleBy = {}));
export var HeatmapSymbolFirstValue;
(function (HeatmapSymbolFirstValue) {
    HeatmapSymbolFirstValue[HeatmapSymbolFirstValue["None"] = 0] = "None";
    HeatmapSymbolFirstValue[HeatmapSymbolFirstValue["ChangePercentage"] = 1] = "ChangePercentage";
})(HeatmapSymbolFirstValue || (HeatmapSymbolFirstValue = {}));
export var HeatmapSymbolSecondValue;
(function (HeatmapSymbolSecondValue) {
    HeatmapSymbolSecondValue[HeatmapSymbolSecondValue["None"] = 0] = "None";
    HeatmapSymbolSecondValue[HeatmapSymbolSecondValue["LastPrice"] = 1] = "LastPrice";
    HeatmapSymbolSecondValue[HeatmapSymbolSecondValue["MarketCap"] = 2] = "MarketCap";
})(HeatmapSymbolSecondValue || (HeatmapSymbolSecondValue = {}));
export var HeatmapSymbolSizeBy;
(function (HeatmapSymbolSizeBy) {
    HeatmapSymbolSizeBy[HeatmapSymbolSizeBy["MarketCap"] = 0] = "MarketCap";
})(HeatmapSymbolSizeBy || (HeatmapSymbolSizeBy = {}));
export var HeatmapSymbolColorBy;
(function (HeatmapSymbolColorBy) {
    HeatmapSymbolColorBy[HeatmapSymbolColorBy["ChangePercentage"] = 0] = "ChangePercentage";
})(HeatmapSymbolColorBy || (HeatmapSymbolColorBy = {}));
export var HeatmapInfoWindowMode;
(function (HeatmapInfoWindowMode) {
    HeatmapInfoWindowMode[HeatmapInfoWindowMode["AttachedToCursor"] = 0] = "AttachedToCursor";
    HeatmapInfoWindowMode[HeatmapInfoWindowMode["Hidden"] = 1] = "Hidden";
})(HeatmapInfoWindowMode || (HeatmapInfoWindowMode = {}));
export var HeatmapInfoState;
(function (HeatmapInfoState) {
    HeatmapInfoState[HeatmapInfoState["None"] = 0] = "None";
    HeatmapInfoState[HeatmapInfoState["NoData"] = 1] = "NoData";
    HeatmapInfoState[HeatmapInfoState["WaitingData"] = 2] = "WaitingData";
    HeatmapInfoState[HeatmapInfoState["NoDataForFilter"] = 3] = "NoDataForFilter";
})(HeatmapInfoState || (HeatmapInfoState = {}));
export function getHeatmapSymbolTitleByKey(value) {
    switch (value) {
        case HeatmapSymbolTitleBy.Symbol:
            return 'property.Symbol';
        case HeatmapSymbolTitleBy.Description:
            return 'property.Description';
        default:
            return '';
    }
}
export function getHeatmapSymbolFirstValueKey(value) {
    switch (value) {
        case HeatmapSymbolFirstValue.None:
            return 'property.None';
        case HeatmapSymbolFirstValue.ChangePercentage:
            return 'property.ChangePercent';
        default:
            return '';
    }
}
export function getHeatmapSymbolSecondValueKey(value) {
    switch (value) {
        case HeatmapSymbolSecondValue.None:
            return 'property.None';
        case HeatmapSymbolSecondValue.LastPrice:
            return 'property.LastPrice';
        case HeatmapSymbolSecondValue.MarketCap:
            return 'property.MarketCap';
        default:
            return '';
    }
}
export function getHeatmapSymbolSizeByKey(value) {
    switch (value) {
        case HeatmapSymbolSizeBy.MarketCap:
            return 'property.MarketCap';
        default:
            return '';
    }
}
export function getHeatmapSymbolColorByKey(value) {
    switch (value) {
        case HeatmapSymbolColorBy.ChangePercentage:
            return 'property.ChangePercent';
        default:
            return '';
    }
}
